import { Suspense } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import { ElearningDetailsRoute } from 'modules/activityDetails/ElearningDetails/routing'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

const QuickGuidesRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:elearningId`} component={ElearningDetailsRoute} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default QuickGuidesRouting
